import { Component } from '@angular/core';
import { RecoverComponent } from '@curbnturf/auth-components/src/lib/recover/recover.component';
import { IonContent } from '@ionic/angular/standalone';

@Component({
  selector: 'curbnturf-recover-modal',
  templateUrl: './recover-modal.component.html',
  styleUrls: ['./recover-modal.component.scss'],
  standalone: true,
  imports: [IonContent, RecoverComponent],
})
export class RecoverModalComponent {}
